import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream py-20 px-4" data-id="element-90">
      <div className="max-w-3xl mx-auto text-center" data-id="element-91">
        <div className="flex justify-center mb-6" data-id="element-92">
          <ShieldCheck className="w-24 h-24 text-teal" data-id="element-93" />
        </div>

        <h2 className="text-3xl md:text-4xl font-heading text-navy mb-8" data-id="element-94">
          "🛡️ Garantía Total 7 Días Sin Preguntas"
        </h2>

        <div className="bg-white p-8 md:p-10 rounded-3xl shadow-lg border-2 border-navy/10 text-left relative" data-id="element-95">
          <div className="space-y-4 text-lg text-gray-700 leading-relaxed italic" data-id="element-96">
            <p data-id="element-97">
              "Prueba El Acelerador 24H durante 7 días completos. Si por
              cualquier motivo no estás satisfecha, escríbenos a nuestro email y
              te devolvemos el 100% de tu dinero en menos de 24 horas. Sin
              formularios, sin preguntas, sin complicaciones.
            </p>
            <p data-id="element-98">
              Tengo tanta confianza en este sistema porque lo he desarrollado
              durante 12 años en consulta clínica real. Si no ves resultados en
              7 días siguiendo el protocolo, no mereces pagar por él."
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-navy/10" data-id="element-99">
            <p className="font-bold text-xl text-navy" data-id="element-100">
              Dra. Elena Martínez Solís
            </p>
            <p className="text-gold font-medium" data-id="element-101">
              Nutricionista Clínica Col. Nº AND-4821
            </p>
          </div>
        </div>
      </div>
    </section>;
}